// extracted by mini-css-extract-plugin
export default {"inputContainer":"ChatInput_inputContainer__W5IF-","input":"ChatInput_input__IvhGq","iconBtn":"ChatInput_iconBtn__KxmjD"};